import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NotFoundComponent } from './errors-pages/not-found/not-found.component';
import { AccessDeniedComponent } from './errors-pages/access-denied/access-denied.component';
import { AuthGuard } from '../common/auth.guard';

const appRoutes: Routes = [
  {
    path: '',
    loadChildren: 'app/_layout/app-basic/app-basic-layout.module#AppBasicRoutingModule'
  },
  {
    path: '',
    loadChildren: 'app/_layout/app-public/app-public-layout.module#AppPublicRoutingModule'
  },
  {
    path: '403',
    component: AccessDeniedComponent,
  },
  {
    path: '401',
    component: NotFoundComponent,
  },
    // Otherwise redirect to home
  { path: '**', redirectTo: '' }
];

export const routing = RouterModule.forRoot(appRoutes);



// WEBPACK FOOTER //
// ./src/app/app.routing.ts